import { styled } from '@mui/material/styles';
import { ToolbarButton } from '../lib/dataGrid';

/**
 * A grid toolbar button that shows whether its tool is ON — the filter hiding
 * rows, the search narrowing them, the Sammelbearbeitung and the PDF export
 * standing ready over ticked rows.
 *
 * The mark used to be a 6px dot in the brand brown, very nearly invisible on
 * the cream toolbar — and a filter nobody notices is a list that quietly lies
 * about what the project holds. So the ICON itself takes the colour, and the
 * badge beside it says how many rather than merely "something".
 *
 * `info` because that is what the colour already says everywhere else in this
 * app (every `severity="info"` Alert): a notice, not a fault. The same tone
 * marks the funnel on a filtered column header (see the MuiDataGrid override in
 * theme.ts). Sorting is deliberately NOT in it: every grid opens sorted, so its
 * arrow stands on screen at all times and a colour there would say nothing.
 *
 * No tinted ground behind the icon: a filled patch under a toolbar icon reads
 * as a pressed or disabled state.
 *
 * Styled rather than given an `sx`: the grid's own ToolbarButton takes a
 * className and no system props.
 */
const ActiveToolButton = styled(ToolbarButton, {
    shouldForwardProp: (prop) => prop !== 'active'
})<{ active?: boolean }>(({ theme, active }) =>
    active ? { color: theme.palette.info.main } : {}
);

export default ActiveToolButton;
